import script from "./AnalysisForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalysisForm.vue?vue&type=script&setup=true&lang=ts"

import "./AnalysisForm.vue?vue&type=style&index=0&id=3ccf7a82&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccf7a82"]])

export default __exports__